import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Typography
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useHistory, useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { ScoringCFIT } from "../../../../graphql/mutations";
import { getCFIT, getCandidateByID, getLogActivityCFIT } from "../../../../graphql/query";
import { getDetailCandidate } from "../../../../shared/atom/detailCandidate";
import { getDataCFIT } from "../../../../shared/atom/getDataCFIT";
import { globalSuccessAtom } from "../../../../shared/globalStates";
import { swalRemoveChild, toastError } from "../../../../shared/helpers";
import SimulationTest from "./Mostest1/SimulationTest";
import { GoToNextSection, checkValuesHasNull } from "./helpers";

const Section4 = () => {
  const waktuPengerjaan = 300000;
  const [Loading, setLoading] = useState(true);

  const { showConfirmationModal } = useConfirmationModal();
  const { id } = useParams();
  const client = useApolloClient();
  const [CFIT, setCFIT] = useRecoilState(getDataCFIT);
  const setDetailCandidate = useSetRecoilState(getDetailCandidate);
  const [listQuestion, setListQuestion] = useState([]);
  const [index, setIndex] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [loadCount, setLoadCount] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [selected, setSelected] = useState(null);
  const [values, setValues] = useState({
    show_instruction: true,
    cfit_second_remaining: waktuPengerjaan,
    data: [],
  });
  const [instruction, setInstruction] = useState(true);
  const [simulation, setSimulation] = useState(false);
  const history = useHistory();
  const setSuccess = useSetRecoilState(globalSuccessAtom);

  useEffect(() => {
    setLoading(true);

    if (isEmpty(CFIT)) {
      //jika soal CFIT null maka get ulang
      getCFIT(client).then((result) => {
        setCFIT(result);
        setListQuestion(
          result.filter((item) => {
            return item.section === 4;
          })
        );
      });
    } else {
      if (!isEmpty(CFIT)) {
        setListQuestion(
          CFIT.filter((item) => {
            return item.section === 4;
          })
        );
      }
    }
    //Pertama kali load maka state value diperbarui
    const storageValue = localStorage.values;
    if (!storageValue) {
      //@remind get log from api
      getLogActivityCFIT(client).then((response) => {
        if (isEmpty(response)) {
          return;
        }
        response["data"] = response["log"];
        delete response.__typename;
        response.log.map((item) => {
          delete item?.__typename;
          return item;
        });
        delete response.log;
        const i = response.data.filter((item) => item?.section === 4).length;
        setIndex(i);
        setStartTime(Date.now() + response.cfit_second_remaining);
        setValues(response);
      });
      return;
    } else {
      const decoded = JSON.parse(atob(storageValue));
      const i = decoded.data.filter((item) => item?.section === 4).length;
      setIndex(i);
      setStartTime(Date.now() + decoded.cfit_second_remaining);
      setValues(decoded);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (Loading || !listQuestion.length) return;
    localStorage.setItem("values", btoa(JSON.stringify(values)));
    handleInstruction();
    if (values.cfit_second_remaining === 0 && !values.show_instruction) {
      scoringCFIT();
    }
    if (listQuestion.length > 0) {
      if (values.isSection4Done) {
        history.push("/career/assessment");
      }
      if (GoToNextSection(values, listQuestion, index)) {
        if (checkValuesHasNull(values, listQuestion)) {
          confirmationAlert(
            "Jawaban anda banyak yang belum diisi, apakah anda yakin ingin menyelesaikan section 4?"
          );
        } else {
          confirmationAlert(
            "Waktu anda masih tersisa, apakah anda yakin ingin menyelesaikan section 4?"
          );
        }
        return;
      } else if (listQuestion[index - 1]?.question_number === listQuestion.length) {
        scoringCFIT();
      }
    }
    if (GoToNextSection(values, listQuestion, index)) return null;
    setLoaded(false); //@option showloading on image load
    setSelected("");
    if (
      index !== listQuestion?.at(-1)?.id &&
      values?.data?.slice(listQuestion.slice(0)[0]?.id - 1, listQuestion.slice(-1)[0]?.id)
        .length === index
    )
      return;
    setIndex(index + 1);
  }, [values, listQuestion]);

  const confirmationAlert = async (text) => {
    const show = await showConfirmationModal({
      contentText: <p>{text}</p>,
    });

    if (show.isConfirmed) {
      scoringCFIT();
    }
  };

  const handleInstruction = () => {
    if (!listQuestion.length) return;
    const i = values.data.filter((item) => item?.section === 4).length;
    if (i === 0 && listQuestion[0].id - 1 !== values.data.length) {
      history.push("/career/mostest-1/3");
    }
    if (
      i < listQuestion.length &&
      i !== 0 &&
      values.cfit_second_remaining !== 0 &&
      values.data.length !== 0
    ) {
      setInstruction(false);
      return;
    }
    if (values.show_instruction === false) {
      setInstruction(false);
    } else {
      setInstruction(true);
    }
  };

  const onComplete = () => {
    swalRemoveChild();
    setValues({ ...values, cfit_second_remaining: 0 });
  };

  const handleImageLoad = () => {
    if (loadCount <= 1) {
      setLoadCount(loadCount + 1);
    } else {
      setLoaded(true);
    }
  };

  const scoringCFIT = async () => {
    const cleanValues = values.data.filter((item) => item);
    const scoring = await ScoringCFIT(client, cleanValues);
    if (scoring.status !== "000") {
      toastError(
        `Error, Code: ${scoring.errMsg.networkError.result.errors[0].extensions.code}, Please contact HR and provide the error code`
      );
    } else {
      localStorage.removeItem("values");
      history.push("/career/mostest-1");
      getCandidateByID(client).then(setDetailCandidate);
      setSuccess(true);
    }
  };

  const handleTime = () => {
    const timeLeft = startTime - Date.now();
    values.cfit_second_remaining = timeLeft;
  };

  const handleNext = () => {
    handleTime();

    const list = {
      section: listQuestion[index].section,
      question_number: listQuestion[index].question_number,
      answer: selected,
    };

    const data = [...values.data];
    data[listQuestion.slice(0)[0].id - 1 + index] = list;
    setValues({
      ...values,
      data: data,
    });
  };

  const handleStart = () => {
    setValues({
      ...values,
      show_instruction: false,
      cfit_second_remaining: waktuPengerjaan,
    });
    setIndex(0);
    setInstruction(false);
    setStartTime(waktuPengerjaan + Date.now());
  };

  const handleStartSimulasi = () => {
    setSimulation(true);
  };

  return (
    <>
      {instruction ? (
        <React.Fragment>
          {(() => {
            if (simulation) {
              return <SimulationTest id={id} handleStart={handleStart} />;
            } else {
              return (
                <Card variant="outlined" sx={{ margin: "auto" }}>
                  <CardHeader
                    title={
                      <Typography variant="h5" component="h5">
                        Intruksi Section 4
                      </Typography>
                    }
                  />
                  <CardContent>
                    <Box>
                      <Typography className="text-textSecondary" component="p">
                        Pilihlah satu dari kelima jawaban yang mencerminkan kondisi yang sama dengan
                        gambar setelah ini.
                      </Typography>
                    </Box>
                    <Box textAlign="center" marginTop="20px">
                      <Button variant="contained" color="primary" onClick={handleStartSimulasi}>
                        Mulai Simulasi
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              );
            }
          })()}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box margin={2} display={"flex"} justifyContent="space-between">
            <Typography
              component="div"
              fontSize={20}
              textTransform="uppercase"
              sx={{ fontWeight: "500 !important" }}>
              Soal
              {` ${listQuestion[index]?.question_number}/${listQuestion.length}`} | Section 4
            </Typography>

            <Typography
              component="div"
              fontSize={20}
              textTransform="uppercase"
              sx={{ fontWeight: "500 !important" }}>
              <Countdown
                date={startTime}
                renderer={({ minutes, seconds }) => {
                  return <span>{`${minutes} : ${seconds}`}</span>;
                }}
                onComplete={onComplete}
              />
            </Typography>
          </Box>
          <Divider sx={{ marginY: "20px" }} />
          {!loaded && (
            <Box textAlign="center" my={3}>
              <CircularProgress />
            </Box>
          )}
          <Box justifyContent="center" textAlign="center" display={!loaded ? "none" : ""}>
            <Box margin="auto" width={200}>
              <img
                onLoad={() => handleImageLoad()}
                style={{
                  display: "inline-block",
                  width: "100%",
                  height: "auto",
                }}
                src={listQuestion[index]?.question}
                alt={`Question ${listQuestion[index]?.question_number}`}
              />
            </Box>
            <Box>
              <Grid container textAlign="center" justifyContent="center" spacing={2} my={2}>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer1.score}</h5>
                    <Input
                      type="radio"
                      checked={selected === "A"}
                      onChange={() => {
                        setSelected(listQuestion[index]?.answer1.score);
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer1.image}
                      alt={listQuestion[index]?.answer1.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer2.score}</h5>
                    <Input
                      type="radio"
                      checked={selected === "B"}
                      onChange={() => {
                        setSelected(listQuestion[index]?.answer2.score);
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer2.image}
                      alt={listQuestion[index]?.answer2.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer3.score}</h5>
                    <Input
                      type="radio"
                      checked={selected === "C"}
                      onChange={() => {
                        setSelected(listQuestion[index]?.answer3.score);
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer3.image}
                      alt={listQuestion[index]?.answer3.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer4.score}</h5>
                    <Input
                      type="radio"
                      checked={selected === "D"}
                      onChange={() => {
                        setSelected(listQuestion[index]?.answer4.score);
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer4.image}
                      alt={listQuestion[index]?.answer4.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer5.score}</h5>
                    <Input
                      type="radio"
                      checked={selected === "E"}
                      onChange={() => {
                        setSelected(listQuestion[index]?.answer5.score);
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer5.image}
                      alt={listQuestion[index]?.answer5.score}
                    />
                  </label>
                </Grid>
                {/* <Grid item>
              <label style={{ cursor: "pointer" }}>
                <h5>{listQuestion[index]?.answer6.score}</h5>
                <Input
                  type="radio"
                  checked={selected === "F"}
                  onChange={() => {
                    setSelected(listQuestion[index]?.answer6.score);
                  }}
                  style={{
                    position: "absolute",
                    opacity: 0,
                    width: 0,
                    height: 0,
                  }}
                />
                <img
                  onLoad={() => handleImageLoad()}
                  src={listQuestion[index]?.answer6.image}
                  alt={listQuestion[index]?.answer6.score}
                />
              </label>
            </Grid> */}
              </Grid>
            </Box>
            <Box my={5} textAlign="center">
              <Button
                onClick={() => handleNext()}
                disabled={
                  isEmpty(selected) || selected.includes(undefined) || selected.includes(null)
                    ? true
                    : false
                }
                variant="contained"
                color="primary">
                {listQuestion[index]?.question_number === listQuestion.length
                  ? "Selesai"
                  : "Selanjutnya"}
              </Button>
            </Box>
          </Box>
          <Divider sx={{ marginY: "20px" }} />
          <Box textAlign="center" display="grid" margin="20px">
            <ul>
              {listQuestion.map((item, i) => (
                <li key={i}>
                  <span
                    className="text-primary-main-hover bg-neutral-n2-hover"
                    onClick={() => {
                      setIndex(item.question_number - 1);
                      if (item.question_number === index + 1) {
                        return;
                      } else {
                        setLoaded(false);
                      }
                      setSelected(values.data[item.id - 1]?.answer);
                    }}
                    style={{
                      float: "left",
                      width: "8%",
                      margin: "5px",
                      border: "2px solid #e1e1e1",
                      cursor: "pointer",
                      background:
                        (item.question_number === index + 1 && "#F0F0F0") ||
                        (values.data[item.id - 1]?.answer !== null &&
                          values.data[item.id - 1]?.answer !== undefined &&
                          "#D9D9D9"),
                    }}>
                    {i + 1}
                  </span>
                </li>
              ))}
            </ul>
          </Box>
        </React.Fragment>
      )}
    </>
  );
};

export default Section4;
